import React, { ChangeEvent, useCallback, useState } from 'react';

import qs from 'qs';
import { useHistory } from 'react-router-dom';

import { Box, Button, Stack, TextField } from '@mui/material';

import InputCruiseLineSelect from '~/components/Cruises/components/Selects/InputCruiseLineSelect';
import { Filter, useCruiseShips } from '~/components/Cruises/context/useCruiseShips';

import { CruiseLine } from '~/services/cruises/CruiseLineService';

export default function ShipSearch() {
  const { setFilter, filter } = useCruiseShips();
  const [form, setForm] = useState<Filter>({
    name: filter.name,
    cruiseLine: filter.cruiseLine,
  });

  const history = useHistory();

  const updateFilters = (filter: Filter): void => {
    setFilter(filter);
    history.push(`/cruises/ships?${qs.stringify(filter)}`);
  };

  const handleCruiseLineChange = useCallback(
    (cruiseLine: CruiseLine) => {
      setForm({
        ...form,
        cruiseLine: cruiseLine?.name || undefined,
      });
    },
    [form],
  );

  const handleNameChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setForm({
        ...form,
        name: e.target.value || undefined,
      });
    },
    [form],
  );

  const handleSubmit = useCallback(() => {
    updateFilters(form);
  }, [form, updateFilters]);

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Box flexGrow={1}>
        <TextField
          label="Name"
          type="text"
          name="name"
          placeholder="Search by name"
          fullWidth
          value={form.name}
          onChange={handleNameChange}
        />
      </Box>

      <Box flexGrow={1}>
        <InputCruiseLineSelect label="Cruise line" value={form.cruiseLine} onChange={handleCruiseLineChange} />
      </Box>

      <Box>
        <Button variant="contained" type="button" onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    </Stack>
  );
}
